import { useCampaigns } from '../../../../hooks/queries';

export const useSuggestedCampaigns = (search: string, page?: number, isRecurring?: boolean) =>
  useCampaigns({ search, page, isRecurring });
